var path = require('../internals/path');
var global = require('../internals/global');
var aFunction = function aFunction(variable) {
  return typeof variable == 'function' ? variable : undefined;
};
module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};